<template>
  <div class="related-news">
    <div
      class="related-news__news related-news__news--next"
      @click="changePostHandler(getNextPostID)"
      v-if="currentPostID !== 6"
    >
      <div class="header">
        <span>Zobacz następny punkt</span>
        <img src="../assets/img/arrow-right.svg" alt />
      </div>
      <div class="post bottom-line">
        <h4 class="post-title">{{posts[getNextPostID].subtitle}}</h4>
      </div>
    </div>
    <div
      class="related-news__news related-news__news--prev"
      @click="changePostHandler(getPreviousPostID)"
      v-if="currentPostID !== 0"
    >
      <div class="header">
        <span>Zobacz poprzedni punkt</span>
        <img src="../assets/img/arrow-left-black.png" alt />
      </div>
      <div class="post bottom-line">
        <h4 class="post-title">{{posts[getPreviousPostID].subtitle}}</h4>
      </div>
    </div>
  </div>
</template>

<script>
import { bus } from "../main";

import postsData from "../singlePostsData";

export default {
  name: "RelatedPosts",
  data: function() {
    return {
      posts: postsData
    };
  },
  props: {
    currentPostID: Number
  },
  methods: {
    changePostHandler(postID) {
      bus.$emit("changePost", postID);
    }
  },
  computed: {
    getPreviousPostID() {
      switch (this.currentPostID) {
        case 1:
          return 0;
        case 2:
          return 1;
        case 3:
          return 2;
        case 4:
          return 3;
        case 5:
          return 4;
        case 6:
          return 5;
        default:
          return 1;
      }
    },
    getNextPostID() {
      switch (this.currentPostID) {
        case 1:
          return 2;
        case 2:
          return 3;
        case 3:
          return 4;
        case 4:
          return 5;
        case 5:
          return 6;
        case 6:
          return 6;
        default:
          return 1;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 15px;
  line-height: 1.6;
  margin-bottom: 20px;

  img {
    &:hover {
      transform: rotate(-30deg);
    }
  }
}

.related-news {
  &__news {
    position: relative;
    margin-top: 30px;
    cursor: pointer;
  }
}

.post {
  &:not(:last-child) {
    margin-bottom: 45px;
  }
  h4 {
    font-size: 24px;
    line-height: 1.33;
    color: $primary-color;
    font-weight: 600;
    cursor: pointer;

    span.block {
      display: inline;
    }

    span.dash {
      display: none;
    }
  }
}
</style>